<script>
import ChatRoom from "@/views/chats/ChatRoom.vue"
import { v4 as uuid } from "uuid"
// import DateRangePicker from "@/components/date-range-picker/DateRangePicker.vue"
import ChatNote from "./ChatNote.vue"
import AddContact from "./AddContact.vue"
import UploadChatFile from "./UploadChatFile.vue"
import ChatFile from "./ChatFile.vue"
import ChatBubble from "./ChatBubble.vue"
import ChatInput from "./ChatInput.vue"

export default {
  components: {
    ChatRoom,
    ChatNote,
    AddContact,
    UploadChatFile,
    ChatFile,
    ChatBubble,
    ChatInput,
  },
  data() {
    return {
      companyId: "",
      curBotId: "",
      curUserId: "",
      openChatNote: false,
      chatRooms: [],
      chatsWs: [],
      messageInput: "",
      chatRoomsWs: null,
      currentChatRoomId: -1,
      takeChatControl: 0,
      chatNoteData: null,
      dialogIsShown: false,
      chatFile: null,
      uploadImageDialog: false,
      searchText: "",
      filteredChatRooms: [],
      websocketBaseUrl: process.env.VUE_APP_REST_API_WEBSOCKET,
      isWide: false,
      isShowChatRoomsList: false,
    }
  },
  created() {
    // get all chatrooms and their chats
    this.getCurrentUserData()
      .then((response) => {
        if (response) {

          // TODO: get current online chat room
          this.companyId = String(response.companyId)
          this.curUserId = String(response.userId)
          this.curUserAvatar = response.avatar

          // send get request to fetch current bot id
          this.getBotIdByCompanyId()
            .then((response) => {
              this.curBotId = String(response)

              console.log(`current bot id: ${this.curBotId}`)

              this.getAllChatRooms()
                .then((chatRoomsResponse) => {
                  this.chatRooms = chatRoomsResponse

                  console.log(`chat rooms: `)
                  console.dir(this.chatRooms, {
                    depth: 5,
                  })

                  // get the current active chat room by bot id
                  // const botUser

                  // * get the current active chat room
                  this.currentChatRoomId = this.chatRooms.findIndex(
                    (chatRoom) => {
                      // * check if the first user in the list is an applicant, if true then return the second user in the users list (recruiter)
                      if (chatRoom.users[0].account_type === "applicant") {
                        return chatRoom.users[1].is_online
                      } else {
                        // * else return the first user which is gonna be a recruiter
                        return chatRoom.users[0].is_online
                      }
                    }
                  )

                  // * check and fetch recruiter's 'chat control status in the current chat room
                  if (this.currentChatRoomId !== -1) {
                    this.getChatControlStatus(
                      this.chatRooms[this.currentChatRoomId].id
                    )
                      .then((res) => {
                        this.takeChatControl = res
                      })
                      .catch((error) => {
                        this.$toastDanger(
                          "An Error Occurred",
                          `Please check your internet connection and refresh the page`
                        )
                      })
                  }

                  // create websocket for every chat room for chat real time purpose
                  // this.chatsWs = this.chatRooms.map((chatRoom, index) => {
                  //   const newChatWs = this.connectChatWebsocket(chatRoom, index)

                  //   return newChatWs
                  // })

                  // this.connectChatRoomWebsocket()

                  // this.$nextTick(() => {
                  //   // * scroll to the most bottom of the chat
                  //   this.scrollToBottom()
                  // })
                })
                .catch((error) => {
                  this.$toastDanger(
                    "An Error Occurred",
                    `Please check your internet connection and refresh the page`
                  )
                })
            })
            .catch((error) => {
              this.$toastDanger(
                "An Error Occurred",
                `Please check your internet connection and refresh the page`
              )
            })
        }
      })
      .catch((error) => {
        this.$toastDanger(
          "An Error Occurred",
          `Please check your internet connection and refresh the page`
        )
      })

    this.checkScreenSizeWidth()
  },
  mounted() {
    this.$socket.client.on("connect", (data) => {
      console.log(`socket connected`)
    })

    this.$socket.client.on("disconnect", (data) => {
      console.log(`socket disconnected`)
    })

    this.$socket.client.on("refresh_chat_rooms", (data) => {
      console.log(`company id: ${data.company_id}`)
      if (String(this.companyId) === data.company_id) {
        this.getAllChatRooms().then((response) => {
          console.log(`all chat rooms: `)
          console.dir(response, {
            depth: 5,
          })

          this.chatRooms = response
        })

        this.$nextTick(() => {
          setTimeout(() => {
            this.scrollToBottom()
          }, 2500)
        })
      }
    })

    this.$socket.client.on("refresh_chat", (data) => {
      if (String(this.companyId) === data.company_id) {
        const chatRoomId = data.chat_room_id

        const chatRoomsIndex = this.chatRooms.findIndex((chatRoom) => {
          return String(chatRoom.id) === chatRoomId
        })

        console.log(`the chat room index: ${chatRoomsIndex}`)

        if (chatRoomsIndex !== -1 || chatRoomsIndex !== null) {
          const chatData = data

          delete chatData.company_id

          this.chatRooms[chatRoomsIndex].chats.push(chatData)

          if (chatData.read === false && chatData.user_id !== this.curBotId) {
            this.chatRooms[chatRoomsIndex].unread_messages += 1
            console.log(`last`)
          }

          this.$nextTick(() => {
            this.scrollToBottom()
          })
        }
      }
    })

    // * add sockets for chat notes and chat tags
    this.$socket.client.on("refresh_chat_notes_tags", (data) => {
      if (data.company_id === this.companyId) {
        const applicant = this.getCurrentChatRoomApplicant()
        this.getChatNoteTagData(applicant)
      }
    })

    window.addEventListener("resize", this.checkScreenSizeWidth)

    this.$nextTick(() => {
      setTimeout(() => {
        this.scrollToBottom()
      }, 2500)
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenSizeWidth)
  },
  methods: {
    toggleChatRoomsList(status) {
      console.log(
        `show chat rooms list: ${this.isShowChatRoomsList}, is wide: ${this.isWide}`
      )
      this.isShowChatRoomsList = status
    },
    checkScreenSizeWidth() {
      this.isWide = window.innerWidth >= 768
      console.log(`this is wide: ${this.isWide}`)
    },
    getApplicantOnlineStatus(chatRoom) {
      const applicant = chatRoom.users.filter(
        (user) => user.account_type === "applicant"
      )

      console.log(`applicant online status: `)
      console.dir(applicant, {
        depth: 5,
      })

      return applicant[0].is_online
    },
    scrollToBottom() {
      const chatContainer = this.$el.querySelector("#chatContainer")

      if (chatContainer) {
        chatContainer.scrollTop = chatContainer.scrollHeight
      }
    },
    async getBotIdByCompanyId() {
      const response = await this.$http.get(
        `/api/chats/get-bot/${this.companyId}`
      )

      return response.data
    },
    // connectChatRoomWebsocket() {
    //   this.chatRoomsWs = new WebSocket(
    //     `${this.websocketBaseUrl}/api/chats/chat-rooms-ws/${this.companyId}/true`
    //   )
    //   console.log(this.chatRoomsWs)

    //   this.chatRoomsWs.onopen = () => {
    //     console.log(`chat room websocket connected!`)

    //     this.chatRoomsWs.onmessage = (event) => {
    //       // add new chat room to chatRooms
    //       const jsonData = JSON.parse(event.data)
    //       console.log(jsonData)

    //       // TODO: add logic for chat control status
    //       // if (jsonData.controlStatus) {
    //       //     this.takeChatControl = jsonData.controlStatus
    //       // } else {
    //       this.chatRooms = jsonData
    //       this.chatsWs.unshift(this.connectChatWebsocket(this.chatRooms[0]))

    //       this.$nextTick(() => {
    //         this.scrollToBottom()
    //       })
    //       // }
    //     }

    //     this.chatRoomsWs.onerror = (error) => {
    //       console.log(`chat room websocket error: ${error}`)
    //       this.chatRoomsWs.close()
    //       this.chatRoomsWs = null
    //       alert(
    //         `Encountered error when fecthing data! Please check your internet connection and refresh the page`
    //       )
    //     }

    //     this.chatRoomsWs.onclose = () => {
    //       console.log(`chat room websocket disconnected!`)
    //       setTimeout(this.connectChatRoomWebsocket, 3000)
    //     }
    //   }
    // },
    // connectChatWebsocket(chatRoom) {
    //   const index = this.chatRooms.indexOf(chatRoom)

    //   const newChatWs = new WebSocket(
    //     `${this.websocketBaseUrl}/api/chats/chats-ws/${chatRoom.id}/${this.curUserId}`
    //   )

    //   newChatWs.onopen = () => {
    //     console.log(`connected`)

    //     newChatWs.onmessage = (event) => {
    //       console.log(`event data: ${JSON.parse(event.data)}`)
    //       const jsonData = JSON.parse(event.data)
    //       this.chatRooms[index].chats.push(jsonData)
    //       console.log(`read status: ${jsonData.read}`)

    //       if (jsonData.read === false && jsonData.user_id !== this.curBotId) {
    //         this.chatRooms[index].unread_messages += 1
    //       }

    //       this.$nextTick(() => {
    //         this.scrollToBottom()
    //       })
    //     }

    //     newChatWs.onclose = () => {
    //       console.log(`disconnected`)
    //       setTimeout(() => {
    //         this.chatsWs[index] = this.connectChatWebsocket(chatRoom, index)
    //       }, 3000)
    //     }

    //     newChatWs.onerror = (error) => {
    //       console.log(`chat websocket error: ${error}`)
    //       newChatWs.close()
    //       newChatWs = null
    //       alert(
    //         `Encountered error when fecthing data! Please check your internet connection and refresh the page`
    //       )
    //     }
    //   }

    //   return newChatWs
    // },
    async sendMessage(file, caption) {
      const today = new Date(new Date().toUTCString()).toISOString()
      const chatId = String(uuid())
      const currentChatRoom = this.chatRooms[this.currentChatRoomId]

      if (file) {
        const fileId = uuid()

        const newFile = new File(
          [file],
          `${fileId}_${currentChatRoom.id}_${file.name}`,
          {
            type: file.type,
          }
        )

        const filename = `pond-chat-files/${newFile.name}`

        this.closeChatNote()

        // const newFormData = new FormData()
        // newFormData.append("file", newFile)

        try {
          // await this.$http.post("/api/chats/save-file", newFormData, {
          //   headers: {
          //     "Content-Type": "multipart/form-data",
          //   },
          // })

          // * generate presigned upload url

          const uploadUrl = await this.$http.get(
            `/api/pre-signed-url-filename/${filename.replace(
              "/",
              "+"
            )}/${newFile.type.replace("/", "+")}`
          )

          // * upload image

          await fetch(uploadUrl.data.url, {
            method: "PUT",
            headers: {
              "Content-Type": newFile.type,
            },
            body: file,
          })

          const newMessage = {
            id: chatId,
            message: caption,
            media_path: filename,
            created_on: today,
            updated_on: today,
            chat_room_id: String(currentChatRoom.id),
            user_id: String(this.curBotId),
          }
          this.chatRooms[this.currentChatRoomId].chats.push(newMessage)

          this.messageInput = ""

          this.closeUploadImageDialog()

          // * call api save chat to db and send it to twilio
          await this.$http.post("/api/chats/add-new-chat", newMessage)

          // * scroll to bottom after send new message
          this.$nextTick(() => {
            setTimeout(() => {
              this.scrollToBottom()
            }, 50)
          })

          this.$socket.client.emit("new_chat", {
            company_id: this.companyId,
            ...newMessage,
          })

          // this.chatsWs[this.currentChatRoomId].send(JSON.stringify(newMessage))
        } catch (e) {
          // alert(
          //   `Encountered error when sending data! Please check your internet connection and refresh the page`
          // )

          this.$toastDanger(
            "An Error Occurred",
            `Please check your internet connection and refresh the page`
          )
        }
      } else {
        if (this.messageInput.trim()) {
          const newMessage = {
            id: chatId,
            message: this.messageInput,
            media_path: "",
            created_on: today,
            updated_on: today,
            chat_room_id: String(currentChatRoom.id),
            user_id: String(this.curBotId),
          }

          this.chatRooms[this.currentChatRoomId].chats.push(newMessage)

          // * scroll to bottom after send new message
          this.$nextTick(() => {
            setTimeout(() => {
              this.scrollToBottom()
            }, 50)
          })

          this.messageInput = ""
          this.closeChatNote()

          // * call api save chat to db and send it to twilio
          await this.$http.post("/api/chats/add-new-chat", newMessage)

          this.$socket.client.emit("new_chat", {
            company_id: this.companyId,
            ...newMessage,
          })

          // this.chatsWs[this.currentChatRoomId].send(JSON.stringify(newMessage))
        }
      }
    },
    async setActiveChat(index) {
      this.closeChatNote()

      if (!this.isWide) {
        this.toggleChatRoomsList(false)
      }

      const oldRoomUid =
        this.currentChatRoomId !== -1
          ? this.chatRooms[this.currentChatRoomId].id
          : ""

      this.currentChatRoomId = index

      this.$nextTick(() => {
        setTimeout(() => {
          this.scrollToBottom()
        }, 50)
      })

      this.chatRooms[this.currentChatRoomId].unread_messages = 0

      // NOTE: change old chat room online status to false by using the currentChatRoomId variable
      // NOTE: and change the new chat room online status to true by using the index parameter
      try {
        await this.$http.post("/api/chats/change-online-status", {
          new_chat_room_id: this.chatRooms[index].id,
          old_chat_room_id: oldRoomUid,
          user_id: this.curBotId,
        })
      } catch (error) {
        this.$toastDanger(
          "An Error Occurred",
          `Please check your internet connection and refresh the page`
        )
      }

      // change all the "read" value in the current chat room's chats to True
      try {
        await this.$http.post("/api/chats/change-read-status", {
          chat_room_id: this.chatRooms[index].id,
          read: true,
        })
      } catch (error) {
        this.$toastDanger(
          "An Error Occurred",
          `Please check your internet connection and refresh the page`
        )
      }

      try {
        const res = await this.getChatControlStatus(this.chatRooms[index].id)

        this.takeChatControl = res
      } catch (error) {
        console.log(`get chat control status response error: ${error}`)
      }
    },
    async toggleChatNote() {
      this.openChatNote = !this.openChatNote

      if (this.openChatNote) {
        // TODO: get all user chat notes and tags
        // TODO: get the user id first

        const applicant = this.getCurrentChatRoomApplicant()

        try {
          await this.getChatNoteTagData(applicant)
        } catch (error) {
          console.log(`getting chat note error: ${error}`)
          this.$toastDanger(
            "An Error Occurred",
            `Please check your internet connection and refresh the page`
          )
        }
      }
    },
    async getChatNoteTagData(applicant) {
      const response = await this.$http.get(
        `/api/chats/get-user-chat-notes-and-tags/${applicant.id}`
      )

      console.log(`get user chat notes and tags response: ${response.data}`)

      this.chatNoteData = response.data
    },
    closeChatNote() {
      this.openChatNote = false
    },
    async getCurrentUserData() {
      const response = await this.$http.get("/api/user")

      return {
        companyId: response.data.company_id,
        userId: response.data.id,
        avatar: response.data.profile_image_url,
      }
    },
    async getAllChatRooms() {
      const response = await this.$http.get(
        `/api/chats/get-all-chat-rooms/${this.companyId}`
      )

      return response.data
    },
    getRoomName(chatRoom) {
      const roomName = chatRoom.users.filter(
        (user) => user.account_type === "applicant"
      )

      let finalRoomName = ""

      if (roomName[0]) {
        if (roomName[0].fullname) {
          finalRoomName = roomName[0].fullname
        } else {
          finalRoomName = roomName[0].phone_number
        }

        if (chatRoom.closed) {
          finalRoomName += " (CLOSED)"
        }

        return finalRoomName
      }
    },
    getLastChatTime(chatRoom) {
      if (chatRoom.chats) {
        if (chatRoom.chats.length > 0) {
          let lastChatTime = null
          const chat_created_on =
            chatRoom.chats[chatRoom.chats.length - 1].created_on

          console.log(`last chat time: ${chat_created_on}`)
          if (chat_created_on.includes("Z")) {
            lastChatTime = new Date(chat_created_on)
          } else {
            lastChatTime = new Date(`${chat_created_on}Z`)
          }

          const currentHours = lastChatTime.getHours()
          const currentMinute = lastChatTime.getMinutes()

          return `${currentHours > 9 ? currentHours : `0${currentHours}`}.${
            currentMinute > 9 ? currentMinute : `0${currentMinute}`
          }`
        }
      }

      return ""
    },
    getLastChatMessage(chatRoom) {
      if (chatRoom.chats) {
        if (chatRoom.chats.length > 0) {
          return chatRoom.chats[chatRoom.chats.length - 1].message
        }
      }

      return ""
    },
    async changeChatControlStatus(status) {
      this.takeChatControl = status

      // TODO: send websocket to broadcast the status of the chat control
      try {
        await this.$http.post(`/api/chats/set-employer-chat-control-status`, {
          employer_chat_control: status,
          room_id: this.chatRooms[this.currentChatRoomId].id,
        })
      } catch (error) {
        console.log(`change chat control status error: ${error}`)
        this.$toastDanger(
          "An Error Occurred",
          `Please check your internet connection and refresh the page`
        )
      }
    },
    async getChatControlStatus(room_id) {
      try {
        const response = await this.$http.get(
          `/api/chats/employer-chat-control/${room_id}`
        )

        console.log(`response data: ${response.data}`)

        if (response.data) {
          return response.data
        }

        return 0
      } catch (error) {
        console.log(`get chat control status error: ${error}`)
        this.$toastDanger(
          "An Error Occurred",
          `Please check your internet connection and refresh the page`
        )
      }
    },
    async createNewNoteData(noteTagInput) {
      if (!this.chatNoteData) {
        this.chatNoteData = {
          chatNotes: [],
          chatTags: [],
        }
      }

      const today = new Date(new Date().toUTCString()).toISOString()
      const id = uuid()
      const applicant = this.getCurrentChatRoomApplicant()

      const newChatNote = {
        id: String(id),
        note: noteTagInput,
        created_on: today,
        updated_on: today,
        user_id: applicant.id,
      }

      this.chatNoteData.chatNotes.push(newChatNote)

      try {
        await this.$http.post(`/api/chats/add-user-chat-note`, newChatNote)

        this.$socket.client.emit("new_chat_note_tag", {
          company_id: this.companyId,
        })
      } catch (error) {
        console.log(`add user chat note error: ${error}`)
        this.$toastDanger(
          "An Error Occurred",
          `Please check your internet connection and refresh the page`
        )
      }
    },
    async createNewTagData(noteTagInput) {
      if (!this.chatNoteData) {
        this.chatNoteData = {
          chatNotes: [],
          chatTags: [],
        }
      }

      const today = new Date(new Date().toUTCString()).toISOString()
      const id = uuid()
      const applicant = this.getCurrentChatRoomApplicant()

      const newChatTag = {
        id: String(id),
        tag: noteTagInput,
        created_on: today,
        updated_on: today,
        user_id: applicant.id,
      }

      this.chatNoteData.chatTags.push(newChatTag)

      try {
        await this.$http.post(`/api/chats/add-user-chat-tag`, newChatTag)

        this.$socket.client.emit("new_chat_note_tag", {
          company_id: this.companyId,
        })
      } catch (error) {
        console.log(`add user chat tag error: ${error}`)
        this.$toastDanger(
          "An Error Occurred",
          `Please check your internet connection and refresh the page`
        )
      }
    },
    getCurrentChatRoomApplicant() {
      const chatRoomUsers = this.chatRooms[this.currentChatRoomId].users

      const user = chatRoomUsers.filter((user) => {
        return user.account_type == "applicant"
      })

      console.log(`filtered applicant: ${user}`)

      return user[0]
    },
    showDialog() {
      this.dialogIsShown = true
    },
    closeDialog() {
      this.dialogIsShown = false
    },
    showUploadImageDialog() {
      this.uploadImageDialog = true
    },
    closeUploadImageDialog() {
      this.uploadImageDialog = false
    },
    async saveNewContact(userId) {
      try {
        const today = new Date(new Date(Date.now()).toUTCString()).toISOString()

        const newChatRoomId = uuid()

        const newChatRoom = {
          id: String(newChatRoomId),
          closed: false,
          created_on: today,
          updated_on: today,
          company_id: this.companyId,
          chat_room_members: [
            {
              user_id: String(userId),
              chat_room_id: String(newChatRoomId),
              is_online: true,
            },
            {
              user_id: this.curBotId,
              chat_room_id: String(newChatRoomId),
              is_online: false,
            },
          ],
          // chat: null,
        }

        // * save new chat room to db
        const addChatRoomResponse = await this.$http.post(
          `/api/chats/add-new-chat-room`,
          newChatRoom
        )

        if (addChatRoomResponse.data.success) {
          // * trigger real time updates for other recruiters
          this.$socket.client.emit("new_chat_room", {
            company_id: this.companyId,
          })

          this.dialogIsShown = false
        } else {
          this.$toastDanger(
            "An Error Occurred",
            `Please check your internet connection and refresh the page`
          )
        }
      } catch (error) {
        this.$toastDanger(
          "An Error Occurred",
          `Please check your internet connection and refresh the page`
        )
      }
    },
    handleMessageInputChange(message) {
      console.log(`curr message: ${message}`)

      this.messageInput = String(message)
    },
    // hdnleSearchTextChange(event) {
    //     this.searchText = event.value.target

    //     this.filtered
    // },
    getFilteredChatRooms() {
      let filteredChatRooms = []

      if (this.chatRooms) {
        filteredChatRooms = this.chatRooms.filter((chatRoom) => {
          if (chatRoom.users[0].account_type === "applicant") {
            console.log(`applicant on 0`)

            return "fullname" in chatRoom.users[0] && chatRoom.users[0].fullname
              ? chatRoom.users[0].fullname
                  .toLowerCase()
                  .includes(this.searchText.toLowerCase())
              : chatRoom.users[0].phone_number
          } else {
            console.log(`applicant on 1`)
            return "fullname" in chatRoom.users[1] && chatRoom.users[1].fullname
              ? chatRoom.users[1].fullname
                  .toLowerCase()
                  .includes(this.searchText.toLowerCase())
              : chatRoom.users[1].phone_number
          }
        })
      }

      return filteredChatRooms
    },
  },
}
</script>

<template>
  <div>
    <!-- Put add new contact dialog here -->
    <AddContact
      v-if="dialogIsShown"
      :show-add-contact-popup="dialogIsShown"
      @on-cancel-click="closeDialog"
      @on-add-contact-click="saveNewContact"
    />

    <!-- upload chat file popup when the recruiter wants to upload a media to the chat -->
    <UploadChatFile
      v-if="uploadImageDialog"
      @on-cancel-click="closeUploadImageDialog"
      @on-send-click="sendMessage"
    />

    <!-- blur the bg when a dialog or popup is shown -->
    <div
      class="chat-container bg-white mb-1"
      :class="{ 'bg-blur': dialogIsShown || uploadImageDialog }"
    >
      <!-- only show the sidebar when the recruiter uses a wide screen or a small screen but the recruiter clicks on the menu icon (which causes to change isShowChatRoomsList to true) -->
      <div
        v-if="isWide || (!isWide && isShowChatRoomsList)"
        class="chat-sidebar bg-white pt-2 d-md-block"
        :class="[!isWide && !isShowChatRoomsList ? 'd-none' : 'd-block w-100']"
      >
        <div class="d-flex justify-content-center w-100">
          <div class="input-group no-shadow round px-2">
            <div class="input-group-prepend">
              <span id="search-chat" class="input-group-text pr-0">
                <feather-icon icon="SearchIcon" class="text-muted" size="14" />
              </span>
            </div>
            <input
              type="text"
              class="form-control border-left-0"
              placeholder="Search or start a new chat"
              aria-label="Search"
              aria-describedby="search-chat"
              v-model="searchText"
            />
          </div>

          <ul class="pr-2 nav navbar-nav d-md-none">
            <li class="nav-item w-100 d-flex justify-content-center">
              <b-link class="nav-link" @click="toggleChatRoomsList(false)">
                <feather-icon class="text-secondary" icon="XIcon" size="21" />
              </b-link>
            </li>
          </ul>
        </div>

        <div class="chats mt-3">
          <div
            class="d-flex align-items-center justify-content-between h-100 mr-2 mb-1"
          >
            <h4 class="text-primary px-2 py-0 m-0">Chats</h4>
            <div
              @click="showDialog"
              class="btn btn-primary p-0 m-0 add-new-contact-btn d-flex justify-content-center align-items-center rounded-circle"
            >
              <feather-icon icon="UserPlusIcon" size="19" />
            </div>
          </div>

          <!-- show all chat rooms data here -->
          <ChatRoom
            v-for="(chatRoom, index) in getFilteredChatRooms()"
            :key="chatRoom.id"
            class="px-2"
            :room-name="getRoomName(chatRoom)"
            :last-chat="getLastChatMessage(chatRoom)"
            :last-chat-time="getLastChatTime(chatRoom)"
            :is-active="index === currentChatRoomId"
            :chat-notification="chatRoom.unread_messages"
            :is-online="getApplicantOnlineStatus(chatRoom)"
            :user-avatar="curUserAvatar"
            @chat-room-click="setActiveChat(index)"
          />
        </div>
      </div>
      <!-- show chat header when there is an active chat -->
      <div
        v-if="currentChatRoomId !== -1"
        class=""
        :class="[!isWide && isShowChatRoomsList ? 'd-none' : 'chat-main']"
      >
        <!-- chat header -->
        <div class="d-flex p-1 justify-content-between align-items-center">
          <!-- implement button to open chat notes -->
          <ul class="pr-1 nav navbar-nav d-md-none">
            <li class="nav-item w-100 d-flex justify-content-center">
              <b-link class="nav-link" @click="toggleChatRoomsList(true)">
                <feather-icon
                  class="text-secondary"
                  icon="MenuIcon"
                  size="21"
                />
              </b-link>
            </li>
          </ul>
          <div class="w-50 d-flex align-items-center">
            <div class="avatar avatar-border">
              <img
                :src="
                  this.curUserAvatar !== 'default' &&
                  $isNotEmpty(this.curUserAvatar) &&
                  this.curUserAvatar !== ''
                    ? this.curUserAvatar
                    : require('@/assets/images/placeholder/no-image.jpg')
                "
                alt="user_avatar"
                height="42"
                width="42"
              />
              <span
                v-if="getApplicantOnlineStatus(chatRooms[currentChatRoomId])"
                class="avatar-status-online"
              />
              <span
                v-else="getApplicantOnlineStatus(chatRooms[currentChatRoomId])"
                class="avatar-status-offline"
              />
            </div>
            <p class="ml-2 mb-0">
              <strong>{{ getRoomName(chatRooms[currentChatRoomId]) }}</strong>
            </p>
          </div>
          <div class="w-50 d-flex justify-content-end">
            <button
              type="button"
              class="btn p-0 btn-circle-size rounded-circle"
              :class="{
                'bg-hovered': !openChatNote,
                'bg-primary text-white': openChatNote,
              }"
              @click="toggleChatNote"
            >
              <feather-icon icon="FileTextIcon" size="20" />
            </button>
          </div>
        </div>
        <!-- chat messages -->
        <div class="chat-messages" id="chatContainer">
          <ChatNote
            v-if="openChatNote"
            :chat-note-data="chatNoteData"
            @close-btn-click="closeChatNote"
            @on-note-submit="createNewNoteData"
            @on-tag-submit="createNewTagData"
          />
          <ChatBubble
            v-for="chat in chatRooms[currentChatRoomId].chats"
            :key="chat.id"
            :chat="chat"
            :cur-bot-id="curBotId"
          />
        </div>

        <!-- chat message input -->
        <ChatInput
          :take-chat-control="takeChatControl"
          :message-input="messageInput"
          :is-closed="chatRooms[currentChatRoomId].closed"
          @on-take-control-click="changeChatControlStatus(1)"
          @on-stop-control-click="changeChatControlStatus(0)"
          @on-message-submit="sendMessage(null, '')"
          @on-message-input-change="handleMessageInputChange"
          @on-upload-btn-click="showUploadImageDialog"
        />
      </div>
      <!-- show the UI below instead if the recruiter uses a small screen and there is no chat room selected yet -->
      <div
        v-else-if="!isWide && currentChatRoomId === -1"
        :class="[!isShowChatRoomsList ? 'chat-main' : 'd-none']"
      >
        <div class="d-flex p-1 justify-content-between align-items-center">
          <ul class="pr-1 nav navbar-nav d-md-none">
            <li class="nav-item w-100 d-flex justify-content-center">
              <b-link class="nav-link" @click="toggleChatRoomsList(true)">
                <feather-icon
                  class="text-secondary"
                  icon="MenuIcon"
                  size="21"
                />
              </b-link>
            </li>
          </ul>
        </div>
        <div
          class="h-100 w-100 d-flex justify-content-center align-items-center bg-lightgray"
        >
          Start chat
        </div>
      </div>
      <div
        v-else
        class="chat-main justify-content-center align-items-center bg-lightgray"
      >
        Start chat
      </div>
    </div>
  </div>
</template>

<style>
.upload-btn {
  cursor: pointer;
}

.upload-btn:hover {
  background-color: #ddd;
  border-radius: 20px;
}

.bg-blur {
  filter: blur(10px);
  -webkit-filter: blur(8px);
}

.add-new-contact-btn {
  width: 40px;
  height: 40px;
  text-align: center;
}

.font-smaller {
  font-size: smaller;
}

.chat-bubble {
  min-width: 50px;
}

.chat-time {
  font-size: x-small;
  color: black;
  margin: 0px;
}

.no-shadow {
  box-shadow: none !important;
}

.chat-container {
  display: flex;
  flex-wrap: wrap;
  height: 85vh;
}

.chat-sidebar {
  width: 100%;
  max-width: 30%;
  background-color: #f7f8fa;
  border-right: 1px solid #ddd;
}

.chat-main {
  width: 100%;
  max-width: 70%;
  display: flex;
  flex-direction: column;
}

.chat-header {
  display: flex;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #ddd;
}

.chat-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
}

.chat-messages {
  flex-grow: 1;
  padding: 10px;
  overflow-y: auto;
  background-color: #eef2f7;
  height: 200px;
}

.bg-lightgray {
  background-color: #eef2f7;
}

/* .sent {
    max-width: 50%;
    background-color: #ff9f43;
    padding: 10px 15px 10px 15px;
    border-radius: 15px 15px 0px 15px;
    color: white;
}

.received {
    max-width: 50%;
    background-color: #bbbbbb;
    padding: 10px 15px 10px 15px;
    border-radius: 15px 15px 15px 0px;
    color: white;
} */

.chat-input {
  display: flex;
  align-items: center;
  padding: 10px;
  border-top: 1px solid #ddd;
}

.chat-input input {
  flex-grow: 1;
  margin-right: 10px;
}

@media (max-width: 767px) {
  .chat-sidebar {
    width: 100%;
    max-width: 100%;
    border: 0px;
  }

  .chat-main {
    width: 100%;
    max-width: 100%;
  }
}

.bg-hovered:hover {
  background-color: rgba(211, 211, 211, 0.243) !important;
  cursor: pointer;
}

.p-small {
  padding: 8px 8px 8px 8px;
}

.btn-circle-size {
  width: 35px;
  height: 35px;
}
</style>
